module.exports = __webpack_public_path__ + "whiteflame.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whiteflame.png
// module id = 887
// module chunks = 0